export default "__VITE_ASSET__cb364e36__"